// Standard page body inside the app shell: phone-friendly padding, and a centred,
// width-capped column on desktop so forms and lists don't stretch edge to edge.
// `wide` is for tables/grids that benefit from the full desktop width; `full` removes the cap
// entirely, filling the parent (detail pages with many side-by-side panels).

import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export function PageContainer({
  children,
  wide = false,
  full = false,
  fill = false,
  className,
}: {
  children: ReactNode;
  wide?: boolean;
  full?: boolean;
  /** Fill the content area instead of growing, so an inner area scrolls: list pages keep their
      filters, column header and pager pinned at every width (on a phone the filters collapse
      behind a button, so the pinned strip stays one row tall). */
  fill?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        // The column and its sections must be allowed to shrink: a nowrap/truncate line deep inside
        // a card otherwise widens its grid track and scrolls the whole page sideways on a phone.
        "mx-auto flex w-full min-w-0 flex-col gap-6 p-4 md:p-6 [&>*]:min-w-0",
        full ? "max-w-none" : wide ? "max-w-screen-2xl" : "max-w-5xl",
        fill && "h-full min-h-0",
        className
      )}
    >
      {children}
    </div>
  );
}
